"use client";

import { useEffect, useState } from "react";
import { getPublicSetting } from "@/app/lib/api/public";
import Script from "next/script";

export function Analytics() {
  const [gaTrackingId, setGaTrackingId] = useState<string>("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchGoogleAnalyticsId = async () => {
      try {
        const setting = await getPublicSetting(5);
        if (setting?.value) {
          setGaTrackingId(setting.value);
        }
      } catch (error) {
        console.error("Error fetching Google Analytics ID:", error);
      } finally {
        setLoaded(true);
      }
    };

    fetchGoogleAnalyticsId();
  }, []);

  if (!loaded || !gaTrackingId) {
    return null;
  }

  return (
    <>
      {/* Google Analytics */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaTrackingId}');
        `}
      </Script>
    </>
  );
} 